var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChevronW = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M14.805 19a.96.96 0 0 1-.687-.293l-5.833-6a1.02 1.02 0 0 1 0-1.414l5.833-6a.95.95 0 0 1 1.375 0 1.02 1.02 0 0 1 0 1.414L10.347 12l5.146 5.293a1.02 1.02 0 0 1 0 1.414.96.96 0 0 1-.688.293"
})));
export default SvgGemChevronW;